/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import inLineStyleObj from './inLineStyleObj';
import jobObj from './jobObj';
import jobVersion from './jobVersionObj';
import utils from './utils';
import _ from 'lodash';

export default class jobUtil {

    constructor(context) {
        this.name = "jobUtil";
        this.context = context;
        console.log("jobUtil");
    }

    saveDefaultJob(Title, body) {

        console.log("jobUtil:saveDefaultJob: %o context: %o ", Title, this.context);

        let jobResponse = {};

        let defaultJob = {jobid: null,
        partnerid: this.context.partnerid(),
        subid: this.context.subid(),
        subparentid: this.context.subparentid(),
        title: Title,
        statusid: 0,
        datecreated: moment().format('YYYY-MM-DD hh:mm:ss'),
        datelastused: moment().format('YYYY-MM-DD hh:mm:ss'),
        jobguid: this.context.util.guid(),
        optionColumn1: null,
        optionColumn2: null,
        optionColumn3: null,
        optionColumn4: null,
        optionColumn5: null,
        optionColumn6: null};

        console.log("jobUtil:saveDefaultJob:defaultJob %o", defaultJob);

        let newJob = new jobObj(defaultJob);
        let jobVersionObj = ko.observable();

        return new Promise((resolve, reject) =>  {

            this.saveJob(newJob).then( response => {
                jobResponse = response.data;
                console.log("jobUtil:saveDefaultJob:defaultJob:saveJob %o", response);
                jobVersionObj(new jobVersion(null));
                jobVersionObj().data = body;
                jobVersionObj().jobid = response.data.jobid;
    
                console.log("jobUtil:saveDefaultJob:defaultJob:jobVersionObj %o", jobVersionObj());
    
                this.saveJobVersion(jobVersionObj).then( response => {
                    //this.getJobList();
                    this.context.eventManager.notifySubscribers({jobRefreshObj:jobResponse},"jobRefresh");
                    resolve(true);
                }).catch( response => {
                    console.log("jobUtil:saveDefaultJob:defaultJob: ERROR %o", response);
                    reject(false);
                });
    
            });

        });

        /*
        this.saveJob(newJob).then( response => {
            jobResponse = response.data;
            console.log("jobUtil:saveDefaultJob:defaultJob:saveJob %o", response);
            jobVersionObj(new jobVersion(null));
            jobVersionObj().data = body;
            jobVersionObj().jobid = response.data.jobid;

            console.log("jobUtil:saveDefaultJob:defaultJob:jobVersionObj %o", jobVersionObj());

            this.saveJobVersion(jobVersionObj).then( response => {
                //this.getJobList();
                this.context.eventManager.notifySubscribers({jobRefreshObj:jobResponse},"jobRefresh");
                return true;
            });

        });
        */

    }

    getJobHomeList() {

        console.log("JobUtil:getJobHomeList");

        let url = this.context.generateApiUrl('/Jobs/jobHomeList');
        let callData = JSON.stringify({ subid: this.context.subid(), subparentid: this.context.subparentid(), partnerid: this.context.partnerid()});

        return new Promise((resolve, reject) =>  {

            $.ajax({
                url: url,
                method: "POST",
                headers: this.context.apiContentType,
                crossDomain: true,
                data: callData
            })
            .done((data, textResponse, request) => {
                resolve(data.data);
            })
            .fail((responseData, textStatus, errorThrown) => {
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling getJobHomeList"},"messageModel");
                reject(responseData);
            });

        });
    }

    getJobHomeChart() {

        console.log("JobUtil:getJobHomeChart");

        let url = this.context.generateApiUrl('/Jobs/jobHomeChart');
        let callData = JSON.stringify({ subid: this.context.subid(), subparentid: this.context.subparentid(), partnerid: this.context.partnerid()});

        return new Promise((resolve, reject) =>  {

            $.ajax({
                url: url,
                method: "POST",
                headers: this.context.apiContentType,
                crossDomain: true,
                data: callData
            })
            .done((data, textResponse, request) => {
                resolve(data.data);
            })
            .fail((responseData, textStatus, errorThrown) => {
                console.log("JobUtil:getJobHomeChart responseData: %o",responseData);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling getJobHomeChart"},"messageModel");
                reject(responseData);
            });

        });
    }

    getJobList() {

        console.log("JobUtil:getJobList");

        //let filter = encodeURI(JSON.stringify({"where": {"jobid":jobid,"subid":subid} }));
        let url = this.context.generateApiUrl('/Jobs/jobList');
        let callData = JSON.stringify({ subid: this.context.subid(), subparentid: this.context.subparentid(), partnerid: this.context.partnerid()});

        return new Promise((resolve, reject) =>  {

            $.ajax({
                url: url,
                method: "POST",
                headers: this.context.apiContentType,
                crossDomain: true,
                data: callData
            })
            .done((response, textResponse, request) => {
                this.context.userJobsArray([]);
                console.log("JobUtil:getJobList response: %o  context.userJobsArray: %o", response.data, this.context.userJobsArray());
                //this.handleGetJobList(response.data);
                for(var t=0, lenTopic=response.data.length; t < lenTopic; t++) 
                {
                    let tempJob = new jobObj(response.data[t]);
                    //Confirm subparentid
                    tempJob.subparentid(this.context.subparentid());
                    this.context.userJobsArray.push(tempJob);
                    //console.log("tempJob: %o ", tempJob);
                }
                resolve(response.data);
            })
            .fail((responseData, textStatus, errorThrown) => {
                console.log("JobUtil:getJobList:Error: %s", textStatus);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling getJobList"},"messageModel");
                reject(responseData);
            });

        });
        

    }

    getJob({ jobid:jobid, subid:subid } ) {
        
        console.log("JobUtil:getJob: jobid: %o, subparentid: %o",jobid, this.context.subparentid());
        //console.log(jobObj);
        //console.log(jobObj.jobid());

        let filter = encodeURI(JSON.stringify({"where": {"jobid":jobid,"subparentid": this.context.subparentid()} }));
        let url = this.context.generateApiUrl('/Jobs' + '?filter=' + filter);
        let callData = JSON.stringify({});
        
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'Get',
                headers: this.context.apiContentType,
                data: callData
            }).then((response) => {
                //console.log("getJob:");
                //console.log(response);
                resolve(response);
            }).catch((error) =>{
                console.log("getJob Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error: jobUtil:getJob",modalBody:"Error getting job information"},"messageModel");
                return;
            });
        });

    }


    saveJob(job) {

        console.log("jobUtil:saveJob: %o", job);

        //job.validate(this.context);

        console.log("jobUtil:saveJob: after validation: %o", job);

        //Confirm subParentID


        //let filter = encodeURI(JSON.stringify({"where": {"jobid":jobid,"subid":subid} }));
        let url = this.context.generateApiUrl('/Jobs/replaceOrCreate');
        let callData = ko.toJSON(job);
        
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).then((response) => {
                console.log("jobUtil:saveJob:");
                console.log(response);
                resolve(response);
            }).catch((error) =>{
                console.log("jobUtil:saveJob Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error: jobUtil:saveJob",modalBody:"Error calling saveJob"},"messageModel");
                return;
            });
        });
    }

    saveJobVersion(jobVerson) {

        console.log("saveJobVersion");

        jobVerson().id = null;
        jobVerson().version = (parseInt(jobVerson().version) + 1);
        jobVerson().mode = this.context.loginStatusObj().Mode;

        console.log(jobVerson());

        //let filter = encodeURI(JSON.stringify({"where": {"jobid":jobid,"subid":subid} }));
        let url = this.context.generateApiUrl('/JobVersions/replaceOrCreate');
        let callData = ko.toJSON(jobVerson);
        
        return new Promise((resolve, reject) => {
            axios({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).then((response) => {
                console.log("saveJobVersion:");
                console.log(response);
                resolve(response);
            }).catch((error) =>{
                console.log("saveJobVersion Error:");
                reject(error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error: jobUtil:saveJobVersion",modalBody:"Error doing saveJobVersion"},"messageModel");
                return;
            });
        });
    }

    addJdmClass(content) {
        console.log("jobUtil:addJdmClass: content: %o", content);
        $(content).each(function(i, item) {
            let $item = $(item);
            console.log("jobUtil:addJdmClass: item: %o", $item);
            $item.addClass('jdm');
            console.log("jobUtil:addJdmClass: item after: %o", $item);
        });

        return content;
    }

    getJobVersion(jobIDStr) {

        //getInLineStyles
        console.log("getJobVersion");
        console.log(jobIDStr);

        let jobid = parseInt(jobIDStr);
        let isnum = /^\d+$/.test(jobIDStr);

        console.log(isnum);
        
        //let filter = encodeURI(JSON.stringify({ "where" : { "subid" : this.context.subid(), "styletype": type}, "order": "stylename"}));
        let url = this.context.generateApiUrl('/JobVersions/CurrentVersion');
        let callData = JSON.stringify({ "JobID": jobid });

        return new Promise((resolve, reject) => {

            if(isnum)
            {
                axios({
                    url: url,
                    method: 'POST',
                    headers: this.context.apiContentType,
                    data: callData
                }).then((response) => {
                    console.log("getJobVersion:");
                    console.log(response);
                    //Add JDM Class to Content
                    //response.data.JobVersion[0].data = this.addJdmClass(response.data.JobVersion[0].data);
                    console.log("jobUtil:getJobVersion: response: %o", response.data.JobVersion[0]);
                    resolve(response.data.JobVersion[0]);
                }).catch((error) =>{
                    console.log("getJobVersion Error:");
                    reject(error);
                    this.context.eventManager.notifySubscribers({modalTitle:"API Error: jobUtil:getJobVersion",modalBody:"Error getting job version"},"messageModel");
                    return;
                });

            }
            else
            {
                reject(null);
            }

        });
    }

    getJobVersionHistory(jobIDStr)
    {
        //{"where": {"jobid":"103302","valid":"1"}, "order":"createdate desc"}
        //getInLineStyles
        console.log("getJobVersionHistory: jobIDStr %s", jobIDStr);
        console.log(jobIDStr);

        let isnum = /^\d+$/.test(jobIDStr);
        let jobid = parseInt(jobIDStr);
        
        let url = this.context.generateApiUrl('/JobVersions/findWitNameAndStatus');
        let callData = JSON.stringify({ "JobID": jobid });

        return new Promise((resolve, reject) => {

            if(isnum)
            {
                axios({
                    url: url,
                    method: 'POST',
                    headers: this.context.apiContentType,
                    data: callData
                }).then((response) => {
                    console.log("getJobVersionHistory:");
                    console.log(response.data.JobVersion);
                    resolve(response.data.JobVersion);
                }).catch((error) =>{
                    console.log("getJobVersionHistory Error:");
                    reject(error);
                    this.context.eventManager.notifySubscribers({modalTitle:"API Error: jobUtil:getJobVersionHistory",modalBody:"Error getting job version history"},"messageModel");
                    return;
                });

            }
            else
            {
                reject(null);
            }

        });

    }
    
    setJobToSelected(jobid) {

        console.log("jobUtil:setJobToSelected jobid: %o", parseInt(jobid));
        ko.utils.arrayForEach(this.context.userJobsArray(), function(item) {

            console.log("jobUtil:setJobToSelected item.jobid(): %o  title: %0", parseInt(item.jobid()), item.title());

            if (parseInt(item.jobid()) == parseInt(jobid)) {
                console.log("jobUtil:setJobToSelected selected job: %o", item);
                item.editorVisible(true);
                item.rowVisible(false);
                
                /*
                let jobElem = document.getElementById(item.jobguid());
                console.log("jobUtil:setJobToSelected scroll to view element: %o id: %o", jobElem, item.jobguid());
                jobElem.scrollIntoView();
                */
            }
            else
            {
                item.editorVisible(false);
                item.rowVisible(true);
            }

        });

    }

    closeAllJobs() {

        console.log("jobUtil:closeAllJobs");
        ko.utils.arrayForEach(this.context.userJobsArray(), function(item) {

            console.log("jobUtil:closeAllJobs item: ", item);

            item.editorVisible(false);
            item.rowVisible(true);
            
        });

    }


    jobCopy({subid = '', jobid = 0, title = 0, withHistory = 'N'})
    {
        console.log("jobUtil:jobCopy");
        console.log("jobUtil:jobCopy: jobid %o  title %o", jobid, title);
        
        let url = this.context.generateApiUrl('/Jobs/copy');
        let callData = JSON.stringify({ "subid": subid, "partnerid": this.context.partnerid(), "jobid": jobid, "title":title, "withHistory": withHistory });

        return new Promise((resolve, reject) => {

            $.ajax({
                url: url,
                method: "POST",
                headers: this.context.apiContentType,
                crossDomain: true,
                data: callData
            })
            .done((response, textResponse, request) => {
                console.log("JobUtil:jobCopy response: %o", response.data);
                resolve(response.data);


            })
            .fail((responseData, textStatus, errorThrown) => {
                console.log("JobUtil:jobCopy:  Error: %s", textStatus);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling jobCopy"},"messageModel");
                reject(responseData);
            });

        });

    }

    jobDelete({jobid = 0, subid = ''})
    {
        console.log("jobUtil:jobDelete");
        console.log("jobUtil:jobDelete: jobid %o", jobid);
        
        let url = this.context.generateApiUrl('/Jobs/delete');
        let callData = JSON.stringify({ "subid": subid, "partnerid": this.context.partnerid(), "jobid": jobid });

        return new Promise((resolve, reject) => {

            $.ajax({
                url: url,
                method: "POST",
                headers: this.context.apiContentType,
                crossDomain: true,
                data: callData
            })
            .done((response, textResponse, request) => {
                console.log("JobUtil:jobDelete response: %o", response.data);
                resolve(response.data);
            })
            .fail((responseData, textStatus, errorThrown) => {
                console.log("JobUtil:jobDelete:  Error: %s", textStatus);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling jobDelete"},"messageModel");
                reject(responseData);
            });

        });

    }

    revertToJobVersion({jobid = 0, jobVersionid = 0})
    {
        console.log("jobUtil:revertToJobVersion");
        console.log("jobUtil:revertToJobVersion: jobid %o  jobVersionid %o", jobid, jobVersionid);
        
        let url = this.context.generateApiUrl('/JobVersions/jobVersionRevert');
        let callData = JSON.stringify({ "jobid": jobid, "jobVersion":jobVersionid});

        return new Promise((resolve, reject) => {

            $.ajax({
                url: url,
                method: "POST",
                headers: this.context.apiContentType,
                crossDomain: true,
                data: callData
            })
            .done((response, textResponse, request) => {
                console.log("JobUtil:revertToJobVersion response: %o", response.data);
                resolve(response.data);


            })
            .fail((responseData, textStatus, errorThrown) => {
                console.log("JobUtil:revertToJobVersion:  Error: %s", textStatus);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling revertToJobVersion"},"messageModel");
                reject(responseData);
            });

        });

    }
}




// WEBPACK FOOTER //
// ./src/objects/jobUtil.js